import app from "flarum/common/app";
/**
 * Abre o `VerificationPromptModal` e resolve com a escolha do operador, ou
 * `null` se ele cancelar. Substitui os `window.prompt` dos fluxos de
 * verify/approve/revoke por uma UI consistente com o resto da extensão.
 */
export default function verificationPrompt(opts) {
  return new Promise(resolve => {
    app.modal.show(() => import(/* webpackChunkName: 'common/components/VerificationPromptModal', webpackMode: 'lazy-once' */ '../components/VerificationPromptModal'), {
      promptTitle: opts.title,
      noteLabel: opts.noteLabel,
      confirmLabel: opts.confirmLabel,
      withTier: !!opts.withTier,
      resolve
    });
  });
}
flarum.reg.add('ziiven-verified', 'common/utils/verificationPrompt', verificationPrompt);flarum.reg.addChunkModule('640', '402', 'ziiven-verified', 'common/components/VerificationPromptModal');flarum.reg.addChunkModule('640', '402', 'ziiven-verified', 'common/components/VerificationPromptModal');